import { useSearchParams } from 'react-router-dom';
import LoginLayout from '../components/LoginLayout';
import AccountContainer from '../container/AccountContainer';
import { IAccountResult } from '../utils/types';

export default function NewAccountPage() {
  const [searchParams] = useSearchParams();
  const phoneNumberSearchParam = searchParams.get('phoneNumber') || '';
  const accountInfo: IAccountResult = {
    phoneNumber: phoneNumberSearchParam,
    citizenshipCountryId: 18884, //static count id 18884 for TR
  };

  return (
    <LoginLayout>
      <AccountContainer user={accountInfo} />
    </LoginLayout>
  );
}
